import { defineStore } from 'pinia';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type {
  IAfterSignup,
  IBonusToast,
  IDepositBeforeClose,
  ISignupBeforeClose,
} from '~/types/postRegistration';

export const useStorePostRegistration = defineStore('strapiPostRegistration', {
  state: () => ({
    signupBeforeClose: {} as ISignupBeforeClose,
    afterSignup: {} as IAfterSignup,
    depositBeforeClose: {} as IDepositBeforeClose,
    bonusToast: {} as IBonusToast,
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadPostRegistration() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'signupBeforeClose',
          'signupBeforeClose.image',
          'afterSignup',
          'afterSignup.image',
          'depositBeforeClose',
          'depositBeforeClose.image',
          'bonusToast',
        ]);
        this.requestPromise = strapi()
          .get('post-registration', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;
      if (response?.data) {
        assignDataToFields(this, response.data);
        return true;
      } else {
        return false;
      }
    },
  },
});
